import React, {useState} from "react";
import {isMobileApp, isMobileIosApp} from "@common/utils/app/appUtils";
import {Moments} from "@common/utils/date/moments"
import Logo from "../assets/image/splash-logo.svg";
import {useCookies} from "react-cookie";
import {isIOS, isAndroid} from 'react-device-detect';
import Modal from "react-modal";

const MORE_NO_VIEW = 'app-modal-visible';
const ANDROID_APP_DOWNLOAD_LINK = "https://play.google.com/store/apps/details?id=kr.co.mobile.adic";
const IOS_APP_DOWNLOAD_LINK = "https://apps.apple.com/kr/app/%EA%B4%91%EA%B3%A0%EC%A0%95%EB%B3%B4%EC%84%BC%ED%84%B0/id1160122235";

function AppConnectView({isFullView}) {
  const [cookies, setCookie, removeCookie] = useCookies([MORE_NO_VIEW]);
  const [checked, setChecked] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const initAppConnectViewOpen = !isFullView && cookies[MORE_NO_VIEW] !== "1"; // "1": 보지않기, 나머지: 보기
  const [isConnectView, setIsConnectView] = useState(initAppConnectViewOpen);

  const handleConfirm = () => {
    const expires = Moments.adDays(1).toDate();
    setCookie(MORE_NO_VIEW, "1", {
      expires,
    });
    if (!isFullView) {
      setModalIsOpen(false);
    }
  };

  const moveAppDownloadLink = () => {
    let appDownLInk = ANDROID_APP_DOWNLOAD_LINK;
    if (isIOS) {
      appDownLInk = IOS_APP_DOWNLOAD_LINK;
    }
    window.open(appDownLInk, "_blank");
  };

  return (
    <>
      {
        !isMobileApp() ?
          isFullView ?
            <AppConnectContent onAppVIewClick={moveAppDownloadLink} onConfirm={handleConfirm}
                               isFullView={isFullView}/>
            :
            isConnectView &&
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
              <div className="modal-content">
                <AppConnectContent onAppVIewClick={moveAppDownloadLink} onConfirm={handleConfirm}
                                   isFullView={isFullView}/>
              </div>
            </Modal>
          :
          null
      }
    </>
  );
}

function AppConnectContent({onAppVIewClick, onConfirm, isFullView}) {
  return (
    <div className="AppConnectView" style={{textAlign: 'center'}}>
      <div className="top-box">
        <img src={Logo} alt="" className="logo"/>
        <p>앱에서 더 많은 기능을 이용해보세요.</p>
        <button className="app-btn" style={{backgroundColor: '#246BFB', marginTop: 10}} onClick={onAppVIewClick}>앱에서 보기</button>
      </div>
      <div className="bottom-box">
        {
          !isFullView &&
          <button className="confirm-btn" onClick={onConfirm}>
            오늘 하루동안 보지 않기 <span className="mdi mdi-logout-variant"></span>
          </button>
        }
      </div>
    </div>
  )
}

export default AppConnectView;
